import { CustomErrorType } from "../interfaces/CustomErrorType";

export default {
    code: 'ERR_RATE_LIMIT',
    statusCode: 429,
    message: {
        en: 'Too many requests',
    },
} as CustomErrorType;